import { setPersonaCheckboxDisplayMutator, selectTempPersonaCheckboxDisplayMutator, } from "../actions/selectMessageListLayoutOption";
import getPersonaCheckboxDisplayOCSSetting from "./getPersonaCheckboxDisplayOCSSetting";
import saveOcsPersonaCheckboxDisplaySetting from "./saveOcsPersonaCheckboxDisplaySetting";
import getLegacyPersonaCheckboxDisplay from "./getLegacyPersonaCheckboxDisplay";
import messageListLayoutStore from "../store/messageListLayoutStore";
import { getGlobalSettingsAccountMailboxInfo } from "owa-account-source-list-store";
import { getAccountScopeUserSettings } from "owa-session-store";
import { isValidPersonaCheckboxDisplayOption } from "../store/schema/PersonaCheckboxDisplayOption";

const PERSONA_CHECKBOX_DISPLAY_PRIME_SETTING_ID = "Mail_PersonaCheckboxDisplay";

let loadPersonaCheckboxDisplay: Promise<void> | undefined;
export default function initializePersonaCheckboxDisplaySetting(): Promise<void> {
    const store = messageListLayoutStore();
    if (store.personaCheckboxDisplay !== null) {
        if (store.tempPersonaCheckboxDisplay === null) {
            Promise.resolve().then(() => {
                if (store.tempPersonaCheckboxDisplay === null) {
                    selectTempPersonaCheckboxDisplayMutator(store.personaCheckboxDisplay);
                }
            });
        }
        return Promise.resolve();
    }
    
    // Prefer primed boot value (synchronous, avoids flash); else fall back to async OCS read.
    const primePersonaCheckboxDisplay = getPrimedPersonaCheckboxDisplay();
    if (primePersonaCheckboxDisplay !== null) {
        setPersonaCheckboxDisplayMutator(primePersonaCheckboxDisplay);
        selectTempPersonaCheckboxDisplayMutator(primePersonaCheckboxDisplay);
        return Promise.resolve();
    }
    
    // Not primed: seed synchronously from the legacy HideSenderImage bit to avoid a boot flash.
    const seededValue = getLegacyPersonaCheckboxDisplay();
    
    setPersonaCheckboxDisplayMutator(seededValue);
    
    if (!loadPersonaCheckboxDisplay) {
        loadPersonaCheckboxDisplay = (async () => {
            try {
                const personaCheckboxDisplay = await getPersonaCheckboxDisplayOCSSetting();
                if (personaCheckboxDisplay !== null) {
                    // Value exists in OCS but was not primed this boot; honor it.
                    setPersonaCheckboxDisplayMutator(personaCheckboxDisplay);
                }
                else {
                    // Server unset: persist the legacy value so future boots use the prime path.
                    try {
                        await saveOcsPersonaCheckboxDisplaySetting(seededValue);
                    }
                    catch {
                        // Best-effort: OCS stays unset and the write is retried on the next boot.
                    }
                }
            }
            catch {
                // Best-effort: keep the already-seeded legacy value when the OCS read fails.
            }
            finally {
                if (store.tempPersonaCheckboxDisplay === null) {
                    selectTempPersonaCheckboxDisplayMutator(store.personaCheckboxDisplay);
                }
            }
        })().finally(() => {
            loadPersonaCheckboxDisplay = undefined;
        });
    }
    return loadPersonaCheckboxDisplay;
}

// Sync-reads the primed value to avoid a boot flash
function getPrimedPersonaCheckboxDisplay(): number | null {
    const primeSettings = getAccountScopeUserSettings(getGlobalSettingsAccountMailboxInfo())?.PrimeSettings;
    const value = primeSettings?.Items?.filter(item => item.Id === PERSONA_CHECKBOX_DISPLAY_PRIME_SETTING_ID).map(item => item.Value?.[0]?.value)[0];
    
    if (value == null) {
        return null;
    }
    
    try {
        const parsedValue = JSON.parse(value);
        return isValidPersonaCheckboxDisplayOption(parsedValue) ? parsedValue : null;
    }
    catch {
        return null;
    }
}
